import emailService from "@/services/emailService";
import actionsService from '@/services/actionsService.js';

export default {
  state: () => ({
    selectedInbox: '',
    emails: {},
    currentQuery: '' // Track the last used query
  }),
  mutations: {
    setSelectedInbox(state, inbox) {
      state.selectedInbox = { ...inbox };
    },
    setEmails(state, { accountName, emails, query = '' }) {
      // Ensure emails is always an array
      const emailList = Array.isArray(emails) ? emails : [emails];

      // If the query changed, reset the emails for this account.
      if (state.currentQuery !== query) {
        state.emails[accountName] = emailList;
        state.currentQuery = query;
      } else {
        // Otherwise, append new emails (pagination)
        state.emails[accountName] = [
          ...(state.emails[accountName] || []),
          ...emailList
        ];
      }

      console.log(state.emails);
    }
  },
  actions: {
    async setSelectedInbox({ commit, dispatch }, inbox) {
      commit('setSelectedInbox', inbox);
      // Reset query when changing inbox
      dispatch('getInboxEmails', '');
    },
    async getInboxEmails({ commit, state }, query = '') {
      let emails = await emailService.getInboxEmails(state.selectedInbox.account_name, query);
      console.log('API returned:', emails);

      // Ensure emails is always an array
      if (!Array.isArray(emails)) {
        emails = emails ? [emails] : [];
      }

      commit('setEmails', {
        accountName: state.selectedInbox.account_name,
        emails,
        query
      });
    },
    setDefaultInbox({ dispatch, rootState }) {
      let connections = rootState.dashboard.connections;
      let emailConnection = connections.find(connection => connection.category === 'Email');
      if (emailConnection) {
        dispatch('setSelectedInbox', emailConnection);
      }
    },
    async draftResponse(_, threadId) {
      let response = await emailService.draftResponse(threadId);
      return response;
    },
    async sendEmail(_,email){
      let sentEmail = await actionsService.sendEmail(email);
      return sentEmail.email;
    },
  },
  getters: {
    selectedInbox: (state) => state.selectedInbox,
    emails: (state) => state.emails
  }
};
